export default "__VITE_ASSET__BOoTR$Lu__"